import { Component, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PercentageValuePipe } from "../../../../core/pipes";

export type ColoredStatusItem = {
  color: string;
  value: number | string | undefined | null;
  label: string;
  isPercentage?: boolean;
  id?: number | string;
};

@Component({
  selector: "adaa-colored-statuses",
  template: `
    <div class="bg-card shadow rounded p-2 d-flex colored-statuses mt-2">
      @for (field of fields(); track $index) {
        <div
          class="mx-1 py-2 rounded shadow px-2 container"
          [style.background-color]="field.color"
          [class.pointer]="field.id !== undefined"
          (click)="field.id !== undefined && itemClicked.emit(field.id)"
        >
          <span class="d-block w-100 text-center fw-bold fs-3 mb-4 text-white">
            {{ field.value | percentageValue: 2 : "-" : "%" : field.isPercentage !== false }}
          </span>

          <span class="d-block w-100 text-center fw-bold text-white"> {{ field.label | translate }} </span>
        </div>
      }
    </div>
  `,
  styleUrl: "./colored-statuses.scss",
  imports: [TranslatePipe, PercentageValuePipe],
})
export class ColoredStatusesComponent {
  fields = input.required<ColoredStatusItem[]>();
  itemClicked = output<number | string>();
}
